<template>
  <div class="prose prose-sm max-w-none text-gray-700">
    <p
      class="whitespace-pre-line break-words"
      v-html="summary"
    />
  </div>
</template>

<script setup lang="ts">
defineProps<{
  summary: string
}>()
</script>

<style scoped>
:deep(a) {
  color: rgb(var(--color-primary-600));
  text-decoration: none;
  border-bottom: 1px solid transparent;
  transition: border-color 0.2s ease;
}
:deep(a:hover) {
  border-bottom-color: rgb(var(--color-primary-600));
}
.break-words {
  word-wrap: break-word;
  overflow-wrap: break-word;
  hyphens: auto;
}
</style>
